import AboutUsSection from './sections/about-us-section/about-us-section';
import BenefitsSection from './sections/benefits-section/benefits-section';
import FormSection from './sections/form-section/form-section';
import JoinUsSection from './sections/join-us-section/join-us-section';
import OurSpiritSection from './sections/our-spirit-section/our-spirit-section';
import PreviewSection from './sections/preview-section/preview-section';
import VacanciesSection from './sections/vacancies-section/vacancies-section';
import ValueSection from './sections/value-section/value-section';
import { ISpecialitiesItem, IVacanciesItem } from './vacancies.interfaces';
import { VacanciesState } from './vacancies.state';

interface VacanciesProps {
  vacancies: IVacanciesItem[];
  specialities: ISpecialitiesItem[];
  vacanciesTotal: number;
  specialitiesTotal: number;
}

const VacanciesComponent = ({ vacancies, vacanciesTotal, specialities, specialitiesTotal }: VacanciesProps) => {
  const {
    previewSection,
    valueSection,
    vacanciesSection,
    formSection,
    aboutUsSection,
    ourSpiritSection,
    benefitsSection,
    joinUsSection,
  } = VacanciesState;
  return (
    <>
      <PreviewSection
        title={previewSection.title}
        subtitle={previewSection.subtitle}
        link={previewSection.link}
        wraps={previewSection.wraps}
      />
      <ValueSection title={valueSection.title} subtitle={valueSection.subtitle} items={valueSection.items} />
      <VacanciesSection
        title={vacanciesSection.title}
        vacancies={vacancies}
        sort={vacanciesSection.sort}
        vacanciesTotal={vacanciesTotal}
      />
      <FormSection
        title={formSection.title}
        subtitle={formSection.subtitle}
        specialities={specialities}
        specialitiesTotal={specialitiesTotal}
      />
      <AboutUsSection
        title={aboutUsSection.title}
        text={aboutUsSection.text}
        imageSrc={aboutUsSection.videoPreviewImage}
        video={aboutUsSection.video}
      />
      <OurSpiritSection
        title={ourSpiritSection.title}
        subtitle={ourSpiritSection.subtitle}
        items={ourSpiritSection.items}
      />
      <BenefitsSection
        title={benefitsSection.title}
        subtitle={benefitsSection.subtitle}
        items={benefitsSection.items}
      />
      <JoinUsSection title={joinUsSection.title} subtitle={joinUsSection.subtitle} images={joinUsSection.images} />
    </>
  );
};

export default VacanciesComponent;
